import PlanSimpleStatusGenerator from "./plan-simple-status-generator";
export default {
    resetedJaw: "",

    reset(steps, status, detailsView) {

        let reseted = "";
        if (detailsView === "extras") {
            app.$bus.$emit("reset/extras");
            reseted = "extras";
        } else if (detailsView === "upper" || detailsView === "lower") {
            this.resetJaw(steps, status, detailsView);
            reseted = "jaw";
            app.$bus.$emit("reset/jaw");
        } else if (detailsView === "total") {
            this.resetAll(steps, status);
            reseted = "all";
        } else if (app.$store.state.simplePlan.selectedRegion >= 0) {
            this.resetRegion(steps, app.$store.state.simplePlan.selectedRegion);
            this.resetedJaw = app.$store.state.simplePlan.selectedJaw;
            reseted = "region";
        } else if (app.$store.getters["simplePlan/totalForJaw"](this.resetedJaw) > 0) {
            this.resetJaw(steps, status, this.resetedJaw);
            reseted = "jaw";
        } else {
            this.resetAll(steps, status);
            reseted = "all";
        }
        this.afterReset(reseted);
        return reseted;
    },

    afterReset(reseted) {
        if (reseted==='extras') return;
        app.$store.state.simplePlan.allowImplantRecalc = false;
        app.$store.state.simplePlan.availableTreatmentPids = [];
        app.$store.state.simplePlan.activeToothNumbers.splice(0, app.$store.state.simplePlan.activeToothNumbers.length);
        app.$set(app.$store.state.simplePlan, "activeTreatmentPid", 0);

        let prev = document.querySelector('.simple-treatment-selector--button-active');
        if (prev) prev.classList.remove('simple-treatment-selector--button-active');
    },

    resetRegion(steps, region) {
        const jaw = app.$store.state.simplePlan.selectedJaw;
        app.$store.state.simplePlan[jaw + "Tpl"] = null;

        for (let i = steps.length - 1; i>=0; i--) {
            const step = steps[i];
            if (step.jaw !== jaw) continue;
            else if (step.fullJaw) steps.splice(i, 1);
            else if (Helper.isStepInRegion(step, region)) {
                const regionIds = Helper.getRegionTeethIds(region);
                let teethIds = step.tooth_id.split(",");
                teethIds = teethIds.filter((id) => {
                    return !regionIds.includes(parseInt(id));
                });
                if (teethIds.length === 0) steps.splice(i, 1);
                else steps[i].tooth_id = teethIds.join(",");
            }
        }
        app.$store.state.simplePlan[jaw+"JawTotal"] = app.$store.getters["simplePlan/totalForJaw"](jaw, true);
        PlanSimpleStatusGenerator.addStatus([], jaw, null, steps);
    },

    resetJaw(steps, status, jaw) {
        app.$store.state.simplePlan[jaw + "Tpl"] = null;

        // Remove steps from jaw
        for (let i = steps.length - 1; i>=0; i--) {
            const step = steps[i];
            if (jaw === step.jaw) steps.splice(i, 1);
        }

        for (let i = status.length - 1; i>=0; i--) {
            const statusItem = status[i];
            const statusJaw = parseInt(statusItem.tooth_id) > 30 ? "lower" : "upper";
            if (jaw === statusJaw) status.splice(i, 1);
        }

        app.$store.state.simplePlan[jaw + "JawTotal"] = 0;
        app.$store.state.simplePlan[jaw + "JawTitle"] = "";
        app.$store.state.simplePlan[jaw + "Tpl"] = null;
        PlanSimpleStatusGenerator.addStatus([], jaw, null, steps);
    },

    resetAll(steps, status) {
        app.$store.commit("simplePlan/reset");
        steps.splice(0, steps.length);
        status.splice(0, status.length);
        app.$store.state.simplePlan["upperTpl"] = null;
        app.$store.state.simplePlan["lowerTpl"] = null;
        app.$store.state.simplePlan["discountAmount"] = 0;
    },
};
